<div class="container-fluid table-responsive-sm">

  <dx-tree-list id="gridContainer"
                keyExpr="id"
                parentIdExpr="parent_id"
                [dataSource]="rows"
                [allowColumnResizing]="true"
                [hoverStateEnabled]="true"
                rowAlternationEnabled="true"
                class="datagrid">

      <dxo-editing 
          mode="cell"
          [allowUpdating]="true">
      </dxo-editing>

      <dxi-column [allowEditing]="false" cellTemplate="product_name" caption="Product Name"></dxi-column>
      <dxi-column [allowEditing]="false" dataField="customer_part_id" caption="Customer Part Identifier"></dxi-column>
      <dxi-column [allowEditing]="false" dataField="barcode" caption="Barcode / UPC"></dxi-column>
      <dxi-column [allowEditing]="true"  cellTemplate="ordered" caption="Total Ordered"></dxi-column>
      <dxi-column [allowEditing]="true"  cellTemplate="completed" caption="Total Completed"></dxi-column>
      <dxi-column [allowEditing]="false" cellTemplate="actions" caption="{{ companyType === 'customer' ? 'Actions' : 'Product Details'}}"></dxi-column>

      <div *dxTemplate="let li of 'product_name'">
        <div *ngIf="!!purchaseOrder && !li.data.parent_id" class="field-value w-auto clickable" title="See attached files if any"
             (click)="openModalWithAttachments(li.data)">
          {{ li.data.product_name || displayProductName(li.data.product_id) }}
        </div>
        <div *ngIf="!purchaseOrder && !li.data.parent_id">
          {{ li.data.product_name || displayProductName(li.data.product_id) }}
        </div>
        <div *ngIf="li.data.parent_id">
          {{ li.data.product_name }}
        </div>
      </div>

      <div *dxTemplate="let li of 'actions'">
        <div class="d-flex align-items-center justify-content-center" *ngIf="!li.data.parent_id">
          <a matTooltip="Go to product"
             target="_blank"
             [routerLink]="getProductLink(li.data)">
            <i class="fa fa-external-link fa-fw pt-1" [style.font-size.px]=20></i>
          </a>
          <a matTooltip="Remove Item" *ngIf="canDelete" (click)="removeItem($event, li.data)">
            <i class="table-icon trash"></i>
          </a>
        </div>
      </div>

      <div *dxTemplate="let li of 'ordered'">
        <input
          type="number"
          min="1"
          class="text-success border-0"
          [value]="li.data.parent_id ? null : li.data.quantity_ordered"
          [disabled]="!canEditQtyOrdered(li.data)"
          (change)="updateItem($event, li.data, !!li.data.parent_id)"
        />
      </div>

      <div *dxTemplate="let li of 'completed'">
        <input
          type="number"
          min="1"
          class="text-success border-0"
          [value]="li.data.quantity_completed || 0"
          [disabled]="!canEditQtyCompleted(li.data)"
          (change)="updateItem($event, li.data, !!li.data.parent_id)"
        />
      </div>
  </dx-tree-list>

</div>
